document.addEventListener("DOMContentLoaded", function() {
    const searchInput = document.getElementById('documentArticleSearch');
    const articles = document.querySelectorAll('.blog-articles__article');
    const sortBySelect = document.getElementById('sort_by');

    function filterAndSortArticles() {
        const searchText = searchInput.value.trim().toLowerCase();
        const sortValue = sortBySelect.value;

        articles.forEach(function(article) {
            const articleText = article.textContent.toLowerCase();
            const matchesSearch = articleText.includes(searchText);
            const matchesSort = article.dataset.sort === sortValue;

            if (matchesSearch && matchesSort) {
                article.style.display = 'block';  // Show matching articles
            } else {
                article.style.display = 'none';   // Hide non-matching articles
            }
        });
    }

    if (searchInput) {
        searchInput.addEventListener('input', filterAndSortArticles);
    } else {
        console.error('Search input element not found.');
    }

    if (sortBySelect) {
        sortBySelect.addEventListener('change', filterAndSortArticles);
    } else {
        console.error('Sort select element not found.');
    }

    // Initially trigger the filter and sort to set the correct state
    filterAndSortArticles();
});
